// Reset scroll on route change. Same pattern as mymcflex — without this the
// admin shell remembers the previous page's scroll position when navigating
// between long lists.
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname, search } = useLocation()
  useEffect(() => { window.scrollTo(0, 0) }, [pathname, search])
  return null
}
